import React from 'react'
import PropTypes from 'prop-types';
import classnames from 'classnames'
import moment from 'moment'
import { Button } from 'react-bootstrap'
import { ListItem, Flex, Loading } from '~/views'

import style from './style.css'

export default class DeviceHistoryBlobItem extends React.Component {

  static propTypes = {
    item : PropTypes.object.isRequired,
    onEvent : PropTypes.func.isRequired
  }

  constructor( props, context ) {
    super( props, context )

    const nLength = props.item && props.item.data && JSON.stringify( props.item.data, null, 2 ).split( '\n' ).length
    this.state = {
      expanded : nLength < 10
    }
  }

  handleExpand = () => {
    this.setState( state => ( { expanded : !state.expanded } ) )
  }

  renderLeft() {
    return null
  }

  preventProp( evt ) {
    evt.preventDefault()
    evt.stopPropagation()
  }

  renderRight( item ) {
    const { expanded } = this.state
    let contents

    const { time, ...rest } = item
    const toDisplay = rest

    if ( expanded ) {
      contents = (
        <pre onClick={this.preventProp}>
          {toDisplay && JSON.stringify( toDisplay, null, 2 )}
        </pre>
      )
    } else {
      contents = (
        <pre>
          {toDisplay && JSON.stringify( toDisplay ).substring( 0, 50 )}
          ...
        </pre>
      )
    }
    return (
      <Flex direction="row" align="flex-start">
        {contents}
      </Flex>
    )
  }

  onEvent = ( type ) => {
    if ( type === 'select' ) {
      this.handleExpand()
    }
  }

  render() {
    const { item, onEvent } = this.props;
    if ( item.type === 'loadMore' ) {
      return (
        <ListItem
          className={style.scriptItem} 
          onEvent={event => onEvent( item, event )}
          item={item}
          rootClick
          title={(
            <div className={style.center}>
              <i className={classnames( 'fa fa-plus', style.loadMore )} />
              {' '}
              Load More Logs
              {' '}
            </div>
          )} />
      )
    } if ( item.type === 'loadingMore' ) {
      return (
        <ListItem
          className={style.scriptItem} 
          onEvent={event => onEvent( item, event )}
          item={item}
          rootClick
          title={<Loading show className={style.center} />} />
      )
    }
    return (
      <ListItem
        className={style.historyItem} 
        onEvent={this.onEvent}
        item={item}
        title={(
          <Flex className={style.title} align="center" justify="flex-start">
            {item.time}
          </Flex>
        )}
        rootClick
        subtitle={moment( item.time ).fromNow()}
        leftView={this.renderLeft( item )}
        rightView={this.renderRight( item )}
        areaClass={style.historyItemArea} />
    )
  }
}
